module.exports = "/assets/data/78b4102fd93490eb7f7b4f107fa8262a-LS4.data.json";